import { compileReportParameters, type ReportParameter } from "../nativeParameters.mjs";
import { asRecord, type JsonRecord } from "./reportDesignerModel";

export function reportParameters(source: unknown): readonly ReportParameter[] {
  const root = asRecord(source);
  return compileReportParameters(asRecord(root.renderer ? asRecord(root.renderer).layout : root.layout).parameters);
}
export function parameterDependencies(layout: JsonRecord, id: string): string[] {
  const dependencies: string[] = [];
  function visit(value: unknown, path: string) {
    if (!value || typeof value !== "object") return;
    if (asRecord(value).param === id) dependencies.push(path);
    Object.entries(value).forEach(([key, child]) => visit(child, `${path}.${key}`));
  }
  visit(layout, "layout");
  return dependencies;
}
